import api from '@/api';
import Utils from '@/utils';

export const actions = {

    adminMatchesGetSectors({dispatch, commit}) {
        return new Promise((resolve, reject) => {

            api({ url: 'matches/sectors', method: 'GET' })
                .then(resp => {
                    commit('adminMatchesSetSectors', resp.data);
                    dispatch('commonEndLoading');
                    resolve(resp.data);
                })
                .catch(err => {
                    dispatch('commonEndLoading');
                    reject(err)
                })
        })
    },

    adminMatchesSave({dispatch, commit}, data) {
        return new Promise((resolve, reject) => {

            data.date = Utils.setDateFormatUSA(data.date);
            data.start_request = Utils.setDateFormatUSA(data.start_request);
            data.end_request = Utils.setDateFormatUSA(data.end_request);

            dispatch('commonStartLoading');
            api({
                url: 'matches' + (data.id ? ('/' + data.id) : ''),
                data: data,
                method: data.id ? 'PUT' : 'POST'
            })
                .then(resp => {
                    resp.data.date = Utils.setDateFormatITA(resp.data.date);
                    resp.data.start_request = Utils.setDateFormatITA(resp.data.start_request);
                    resp.data.end_request = Utils.setDateFormatITA(resp.data.end_request);
                    commit('adminMatchesSetCurrentMatch', resp.data);
                    dispatch('commonEndLoading');
                    resolve(resp.data);
                })
                .catch(err => {
                    dispatch('commonEndLoading');
                    reject(err)
                })
        })
    },

    adminMatchesShow({dispatch, commit}, data) {
        return new Promise((resolve, reject) => {

            dispatch('commonStartLoading');
            api({ url: 'matches/' + data.id, data: data, method: 'GET' })
                .then(resp => {
                    resp.data.date = Utils.setDateFormatITA(resp.data.date);
                    resp.data.start_request = Utils.setDateFormatITA(resp.data.start_request);
                    resp.data.end_request = Utils.setDateFormatITA(resp.data.end_request);
                    commit('adminMatchesSetCurrentMatch', resp.data);
                    dispatch('commonEndLoading');
                    resolve(resp.data);
                })
                .catch(err => {
                    dispatch('commonEndLoading');
                    reject(err)
                })
        })
    },

    adminMatchesSelect() {
        return new Promise((resolve, reject) => {
            api({ url: 'select/all-matches', method: 'POST' })
                .then(resp => {
                    resolve(resp.data);
                })
                .catch(err => {

                    reject(err)
                })
        })
    },

};

